module.exports = __webpack_public_path__ + "img/toHeardBgdark.f6236e52.png";